export default __webpack_public_path__ + "static/media/google.f89b48e4.svg";